import React, { lazy, Suspense } from 'react';
import useMobileViewport from '../../hooks/useMobileViewport';
import './mobile.css';
import Nav from '../../components/Nav';
import Hero from './sections/Hero';
import Founding from './sections/Founding';
import Truth from './sections/Truth';
import Spending from './sections/Spending';
import Ask from './sections/Ask';
import Why from './sections/Why';
import Rewards from './sections/Rewards';
import Trust from './sections/Trust';
import Close from './sections/Close';

const HowItWorks = lazy(() => import('./sections/HowItWorks'));

/**
 * The landing page ("/").
 * Nav lives here (landing-only). Sections get added one at a time.
 *
 * onContactClick is passed from App.js and forwarded to any section
 * that opens the contact modal (e.g. a future contact CTA).
 */
export default function LandingPage({ onContactClick }) {
  const mobile = useMobileViewport();
  return (
    <>
      <Nav mobile={mobile} />
      <Hero mobile={mobile} />
      <Founding mobile={mobile} />
      {!mobile && <Suspense fallback={null}><HowItWorks /></Suspense>}
      {!mobile && <Truth />}
      <Spending mobile={mobile} />
      <Ask mobile={mobile} />
      <Why mobile={mobile} />
      <Rewards mobile={mobile} />
      <Trust />
      <Close mobile={mobile} />
    </>
  );
}